import type { ReactNode } from "react";

// 포트폴리오 코드 발췌는 모두 C++이다. 주석 · 문자열 · 전처리 · 숫자 · 식별자 순서로 한 번 훑어 span으로 감싼다.
const keywords = new Set([
  "alignas", "auto", "bool", "break", "case", "catch", "char", "class", "const", "constexpr", "consteval", "constinit",
  "const_cast", "continue", "decltype", "default", "delete", "do", "double", "dynamic_cast", "else", "enum", "explicit",
  "export", "extern", "false", "final", "float", "for", "friend", "goto", "if", "inline", "int", "long", "mutable",
  "namespace", "new", "noexcept", "nullptr", "operator", "override", "private", "protected", "public", "reinterpret_cast",
  "requires", "return", "short", "signed", "sizeof", "static", "static_assert", "static_cast", "struct", "switch",
  "template", "this", "throw", "true", "try", "typedef", "typeid", "typename", "union", "unsigned", "using", "virtual",
  "void", "volatile", "while",
]);

const token = /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|("(?:\\.|[^"\\\n])*"|'(?:\\.|[^'\\\n])')|(^[ \t]*#[ \t]*[a-z]+[^\n]*)|(\b0x[0-9a-fA-F]+\b|\b\d[\d.]*(?:e[+-]?\d+)?[fFuUlL]*)|([A-Za-z_]\w*)/gm;

function identifierKind(word: string, rest: string): string | undefined {
  if (keywords.has(word)) return "keyword";
  if (/^\s*\(/.test(rest)) return "function";
  if (/^[A-Z][A-Z0-9_]+$/.test(word)) return "constant";
  if (/^[A-Z]/.test(word)) return "type";
  return undefined;
}

export function highlightCode(source: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let last = 0;
  token.lastIndex = 0;
  for (let match = token.exec(source); match; match = token.exec(source)) {
    const index = match.index;
    const [text, comment, string, preprocessor, number, identifier] = match;
    const kind = comment ? "comment" : string ? "string" : preprocessor ? "preprocessor" : number ? "number"
      : identifier ? identifierKind(identifier, source.slice(index + text.length, index + text.length + 4)) : undefined;
    if (!kind) continue;
    if (index > last) nodes.push(source.slice(last, index));
    nodes.push(<span key={index} className={`code-${kind}`}>{text}</span>);
    last = index + text.length;
  }
  if (last < source.length) nodes.push(source.slice(last));
  return nodes;
}
